'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || '3000',
  webpackPort: process.env.WEBPACK_PORT || '3001',
  apiRoot: process.env.API_ROOT || 'http://localhost:3030',
  apiV2Url: process.env.API_V2_URL || 'http://localhost:3030',
  apiTracking: process.env.API_TRACKING || 'https://api-analytic.lookme.dev',
  trackingEnabled: process.env.TRACKING_ENABLED === 'true',
  siteUrl: process.env.SITE_URL || 'http://localhost:3000',
  protocol: process.env.PROTOCOL || 'http://',
  searchEngineDisabled: process.env.SEARCH_ENGINE_DISABLED === 'true',
  debugMode: process.env.DEBUG_MODE === 'true',
  cryptoSecret: process.env.CRYPTO_SECRET,
  googleId: process.env.GOOGLE_ID,
  googleMapKey: process.env.GOOGLE_MAP_KEY,
  // --- Google Analytics ---
  gaEnabled: process.env.GA_ENABLED === 'true',
  gaTrackingCode: process.env.GA_TRACKING_CODE,
  gaDebugMode: process.env.GA_DEBUG_MODE === 'true',
  gaTestMode: process.env.GA_TEST_MODE === 'true',
  // --- End of Google Analytics ---
  fbAppId: process.env.FB_APP_ID,
  fbVersion: process.env.FB_VERSION,
  fbPixelEnabled: process.env.FB_PIXEL_ENABLED === 'true',
  fbPixelCode: process.env.FB_PIXEL_CODE,
  // --- Sentry ---
  sentryEnabled: process.env.SENTRY_ENABLED === 'true',
  sentryDSN: process.env.SENTRY_DSN,
  sentryEnv: process.env.SENTRY_ENV,
  // --- End of Sentry ---
  // --- Download Link ---
  iosLink: process.env.IOS_DOWNLOAD_LINK,
  androidLink: process.env.ANDROID_DOWNLOAD_LINK,
  // --- End of download ---
  app: {
    title: 'Lookme',
    description: '✨ LOOKME.VN - Website Review Đánh Giá ✅ Địa Điểm Làm Đẹp Cao Cấp ✅ Phòng Khám Chất Lượng ✅ Trung Tâm Thể Dục Thể Thao Uy Tín ✅ Tiệm Xăm Hình Cực Đỉnh Trên Toàn Quốc Cho Giới Trẻ ✨',
    head: {
      titleTemplate: '%s',
      meta: [{
        name: 'description',
        content: '✨ LOOKME.VN - Website Review Đánh Giá ✅ Địa Điểm Làm Đẹp Cao Cấp ✅ Phòng Khám Chất Lượng ✅ Trung Tâm Thể Dục Thể Thao Uy Tín ✅ Tiệm Xăm Hình Cực Đỉnh Trên Toàn Quốc Cho Giới Trẻ ✨'
      }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Lookme' }, { property: 'og:image', content: '' }, { property: 'og:locale', content: 'vn_VN' }, { property: 'og:title', content: 'LOOKME' }, {
        property: 'og:description',
        content: '✨ LOOKME.VN - Website Review Đánh Giá ✅ Địa Điểm Làm Đẹp Cao Cấp ✅ Phòng Khám Chất Lượng ✅ Trung Tâm Thể Dục Thể Thao Uy Tín ✅ Tiệm Xăm Hình Cực Đỉnh Trên Toàn Quốc Cho Giới Trẻ ✨'
      }, { property: 'og:url', content: '' }, { property: 'fb:app_id', content: process.env.FB_APP_ID }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 33
// module chunks = 0